<template lang="html">
  <div class="developer-wrapper">
    <!-- <router-link :to="{ name: 'qrDownload'}">qrDownload</router-link> -->
    <!-- <div style="height:100px;">
    </div> -->
    <router-link class="remote-style" :to="{ name: 'remote_xarm'}">Remote Xarm</router-link>
    <!-- <div @click="openRemote"> -- remoteXarm open new -- </div> -->
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      langData: {},
    }
  },
  created: function () {
  },
  mounted: function () {
    // this.qrDownload();
    // this.remoteIP = window.remoteIP;
  },
  methods: {
    openRemote() {
      const remoteIP = window.remoteIP;
      const url = `http://${remoteIP}:18322`;
      window.open(url);
    },
  }
}
</script>

<style scoped>
/* .contain-wrapper {
  width:100%;
  height: 100%;
}
.tip {
  color: #555;
  font-size: 16px;
  text-align: center;
  padding: 15px 0;
} */
.lead-img {
  width: 100%;
}
.remote-style {
  position: absolute;
  /* background: yellow; */
  left: 50px;
  top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue